<div class="generico">
    <h4 class="text-center latopers section-title-login"><b>CONFCOOPERATIVE SERVIZIO REVISIONE</b></h4>
    <h5 class="text-center section-title-login">Cruscotto del revisore</h5>
    <form class="login-form" [formGroup]="form">
      <div class="flex-column form-group">
        <label for="username" class="control-label">
          Nome utente
          <input
            formControlName="userNameOrEmailAddress"
            type="text" class="form-control" id="username">
        </label>
        <p>
          <label for="password" class="control-label">Password:</label>
          <input
            formControlName="password"
            [type]="showPassword ? 'text' : 'password'" class="custom-password" id="password">
          <i class="bi bi-eye-slash" (click)="showPassword = !showPassword"></i>
        </p>
        <label class="control-label">
          <input type="checkbox">
          Ricordami
        </label>
        <div class="accedi">
          <button
            [disabled]="form.invalid"
            type="button" class="btn btn-blue"
            (click)="submit()">Accedi
          </button>
        </div>
      </div>
    </form>
</div>


